import { useMemo } from 'react';
import { useTranslation } from '../components/blocks/localization';
import { RETURN_REASON } from '../constants';

export const useReturnReasons = () => {
    const { t } = useTranslation('returnOrderItemList');

    return useMemo(
        () => [
            {
                value: RETURN_REASON.REMORSE,
                label: t('orderItemReason', { context: RETURN_REASON.REMORSE }),
            },
            {
                value: RETURN_REASON.DEFECTIVE,
                label: t('orderItemReason', { context: RETURN_REASON.DEFECTIVE }),
            },
            {
                value: RETURN_REASON.QUALITY_BELOW_EXPECTED,
                label: t('orderItemReason', { context: RETURN_REASON.QUALITY_BELOW_EXPECTED }),
            },
            {
                value: RETURN_REASON.DESCRIPTION_MISMATCH,
                label: t('orderItemReason', { context: RETURN_REASON.DESCRIPTION_MISMATCH }),
            },
            {
                value: RETURN_REASON.WRONG_ITEM,
                label: t('orderItemReason', { context: RETURN_REASON.WRONG_ITEM }),
            },
            {
                value: RETURN_REASON.GIFT_RETURN,
                label: t('orderItemReason', { context: RETURN_REASON.GIFT_RETURN }),
            },
            {
                value: RETURN_REASON.OTHER,
                label: t('orderItemReason', { context: RETURN_REASON.OTHER }),
            },
        ],
        [t]
    );
};
